module.exports = __webpack_public_path__ + "img/IMG-20200809-WA0009.f57aab26.jpg";